var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWateringCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2801 81.0591C56.5569 84.9903 59.5041 91.9986 58.4634 98.7998L83.2924 114.586L80.0873 100.19C79.2358 96.365 81.6686 92.5386 85.4937 91.687L92.6571 90.0922C92.1852 88.9563 91.9375 87.8436 91.6743 86.6613C86.9673 65.5189 100.267 44.6013 121.409 39.8943C129.286 38.1329 137.515 38.8481 144.969 41.9419C152.424 45.0357 158.741 50.3571 163.056 57.1782C167.371 63.9993 169.473 71.9869 169.075 80.0483C168.677 88.1098 165.798 95.8514 160.832 102.214L170.525 145.751C171.376 149.576 168.943 153.402 165.118 154.254L102.526 168.189C98.7005 169.041 94.8742 166.608 94.0226 162.783L87.6588 134.199L50.8405 110.789C45.1231 114.617 37.542 114.991 31.4043 111.029L50.2801 81.0591ZM154.693 76.2808C154.569 75.0676 154.53 73.9084 154.267 72.7261C151.278 59.3034 137.929 50.8154 124.506 53.8038C111.083 56.7921 102.595 70.1419 105.584 83.5646C105.847 84.7469 106.303 85.8132 106.706 86.9645L154.693 76.2808Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWateringCan);
export default __webpack_public_path__ + "static/media/watering-can.f62c651544bc84af2696abf9c3486336.svg";
export { ForwardRef as ReactComponent };